import { Component, Input, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-admin-modal-layout',
  templateUrl: './admin-modal-layout.component.html',
  styleUrl: './admin-modal-layout.component.scss',
  standalone: false
})
export class AdminModalLayoutComponent {
  @Input() title!: string;
  @Input() saveLabel = 'app.common.save';
  @Input() cancelLabel = 'app.common.cancel';

  @Input() showActions = true;
  @Input() showSave = true;
  @Input() showCancel = true;

  @Input() saveDisabled = false;

  @Output() onSave = new EventEmitter<void>();
  @Output() onClose = new EventEmitter<void>();
  @Output() onAction = new EventEmitter<void>();

  handleCancel(): void {
    if (this.onAction.observed) {
      this.onAction.emit();
    } else {
      this.onClose.emit();
    }
  }
}
